import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Sidebar from "./Sidebar";
import { OfficeSideBar } from "./OfficeSideBar";
import { BuildingOfficeIcon, NewspaperIcon } from "@heroicons/react/24/solid";
const OfficeReports = () => {
  return (
    <div className="p-4 min-h-fit">
      <div>
        <div className="pl-4 flex gap-2 items-center">
          <div>
            <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
          </div>
          <div className="flex flex-col leading tight">
            <h3 className="text-xs font-medium text-gray-500">
              Reports Module
            </h3>
            <h1 className="mr-auto font-bold text-primary text-md uppercase">
              OFFICE REPORTS
            </h1>
          </div>
        </div>
      </div>
      <div className="bg-white flex flex-row h-full ">
        <Router>
          <div
            className="w-1/6 h-full flex sm:w-auto overflow-y-auto flex-col flex-grow
             ml-4 bg-white mt-4 -mr-px z-10"
          >
            <Sidebar />
          </div>

          <div className={"w-5/6 bg-white table-shadow mt-4 mr-4"}>
            {OfficeSideBar.map((main) => {
              return (
                <Switch key={main.title}>
                  <Route
                    index
                    path={main.to}
                    exact
                    component={main.component}
                  />
                  {/* <Redirect exact from="/" to={sub.path} /> */}
                </Switch>
              );
            })}
          </div>
        </Router>
      </div>
    </div>
  );
};
export default OfficeReports;
